import { render, staticRenderFns } from "./AdminListHomeComponent.vue?vue&type=template&id=70c9ea74&scoped=true&"
import script from "./AdminListHomeComponent.vue?vue&type=script&lang=js&"
export * from "./AdminListHomeComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdminListHomeComponent.vue?vue&type=style&index=0&id=70c9ea74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9ea74",
  null
  
)

export default component.exports